"use client"

import { useMemo } from "react"

export { useDebouncedValue } from "@/hooks/use-debounced-value"

export function useOpaqueCredentialSessionId(credential: string): string {
  return useMemo(() => {
    // Rotate synchronously when the credential changes without deriving an ID
    // from, or retaining the value in, the React Query cache key.
    void credential
    return crypto.randomUUID()
  }, [credential])
}
